import { includes } from "lodash"

export const ALL_DATASET_ACCESS_TEAM_ALIAS = "all_dataset_access_team"
export const ALL_BASKETS_TEAM_ALIAS = "all_baskets_access_team"

export const TEAM_ROLES = {
  MEMBER: "Team Member",
  ADMIN: "Team Admin",
} as const

export function isAllAccessTeam(teamAlias: string) {
  return includes([ALL_DATASET_ACCESS_TEAM_ALIAS, ALL_BASKETS_TEAM_ALIAS], teamAlias)
}
